import React from "react";

const ContactDetailsExtra = () => (
  <div className="bg-white rounded-lg shadow-md p-6 mb-8 text-gray-800 leading-relaxed">
    <div className="mb-4">
      <div><b>Deutsch-Arabischer Bildungsverein  e.V.</b></div>
      <div>Im Gettelhagen 80, 38108 Braunschweig</div>
      <div>Tel: <a href="tel:+491598475466" className="text-blue-700 underline">+49 159 8475466</a></div>
      <div>Amtsgericht Braunschweig VR 201250</div>
    </div>
    <div className="mb-4">
      <b>Kontoverbindung:</b><br />
      Deutsch-Arabischer Bildungsverein  e.V.<br />
      Postbank, IBAN: <span className="select-all">DE 77440100460170218460</span><br />
      BIC: <span className="select-all">PBNKDEFF</span>
    </div>
    
    <div className="mb-4">
      <b>Antrag auf Mitgliedschaft:</b><br />
      <a href="/antrag-mitgliedschaft.pdf" download className="text-blue-700 underline mr-2">Download Antrag (PDF version)</a>
      <a href="/antrag-mitgliedschaft.doc" download className="text-blue-700 underline">Download Antrag (DOC version)</a>
    </div>
    <div className="mb-4">
      <b>مركز التواصل و الاستشاره لرابطة التعليم العربي الالماني بالجامعه التقنيه براونشفايغ</b><br />
      <b>Beratungsstelle Deutsch-Arabischer Bildungsverein an der TU Braunschweig</b><br />
      Tel. Nr.: <a href="tel:+491598475466" className="text-blue-700 underline">+49 159 8475466</a> Besuch nach Vereinbarung<br />
      Ansprechpartner: Prof. Adi<br />
      Adresse: 11. Etage im Haus der Elektrotechnik, Hans-Sommer-Straße. 66, 38106 Braunschweig, Deutschland<br />
      
    </div>
  </div>
);

export default ContactDetailsExtra;
